export class SelectBoxItem {
  constructor(public disabled: boolean, public text: string) {}
}

export class ExportFormatWithVersions {
  constructor(public exportFormat: SelectBoxItem, public exportVersions: SelectBoxItem[]) {}
}
